const scrim = require("../../../../../components/scrim/scrim");

let iframe;
let iframeWasSelected = false;

function ensureIframe() {
  if (!iframeWasSelected) {
    iframe = document.getElementById("reportIframe");
    iframeWasSelected = true;
  }
}

export function printHtmlInIframe(html) {
  ensureIframe();
  const doc = iframe.contentWindow.document;

  if (
    iframe.contentWindow &&
    iframe.contentWindow.location.href === "about:blank"
  ) {
    scrim.showLoading();
    doc.open();
    doc.write(
      "<!DOCTYPE html><html><head></head><body>" + html + "</body></html>"
    );
    doc.close();
    iframe.contentWindow.print();
    iframe.onload = null;
    scrim.hideLoading();
  } else {
    iframe.onload = function () {
      scrim.showLoading();
      doc.open();
      doc.write(
        "<!DOCTYPE html><html><head></head><body>" + html + "</body></html>"
      );
      doc.close();
      iframe.contentWindow.print();
      iframe.onload = null;
      scrim.hideLoading();
    };
  }
  iframe.src = "about:blank";
}
